import React from 'react'

const ShoppingPolicy = () => {
  return (
    <div>
      
    </div>
  )
}

export default ShoppingPolicy
